import type { RouteObject } from 'react-router';
import { deviceManagementContainer } from './container.const';
import { deviceManagementContainerInit } from './containerInit.util';
import { DeviceManagementApi } from './domain/hexa/deviceManagementApi.service';
import type { DeviceManagementApiPort } from './domain/hexa/ports/api.model';
import type { DeviceManagementSpiPort } from './domain/hexa/ports/spi.model';
import { registerDeviceManagementTranslations } from './i18n/registerDeviceManagementTranslations';
import { deviceManagementRoutes } from './routes.util';

export interface DeviceManagementBoostrapOptions {
  readonly spi: DeviceManagementSpiPort;
}

export interface DeviceManagementBoostrapReturn {
  readonly api: DeviceManagementApiPort;
  readonly routes: RouteObject[];
}

export function bootstrapDeviceManagement(options: DeviceManagementBoostrapOptions): DeviceManagementBoostrapReturn {
  registerDeviceManagementTranslations();
  deviceManagementContainerInit(options.spi);

  return {
    api: deviceManagementContainer.get(DeviceManagementApi),
    routes: deviceManagementRoutes(options.spi),
  };
}
